var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogleColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_3707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8419 8.18417C15.8419 7.64035 15.7978 7.09359 15.7037 6.55859H8.15787V9.63925H12.479C12.2997 10.6328 11.7236 11.5117 10.8799 12.0703V14.0692H13.4579C14.9718 12.6758 15.8419 10.6181 15.8419 8.18417Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15819 16.0002C10.3158 16.0002 12.1354 15.2918 13.4611 14.0689L10.8832 12.07C10.1659 12.558 9.23994 12.8343 8.16113 12.8343C6.07404 12.8343 4.30443 11.4263 3.66948 9.5332H1.00919V11.5938C2.36726 14.2953 5.13338 16.0002 8.15819 16.0002Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 9.53356C3.33139 8.53999 3.33139 7.46411 3.6665 6.47054V4.40991H1.00914C-0.125525 6.67043 -0.125525 9.33367 1.00914 11.5942L3.6665 9.53356Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15822 3.16644C9.29876 3.1488 10.4011 3.57798 11.2271 4.36578L13.5111 2.08174C12.0649 0.72367 10.1454 -0.0229773 8.15822 0.000539111C5.13341 0.000539111 2.36729 1.70548 1.00922 4.40987L3.66657 6.4705C4.29858 4.57449 6.07113 3.16644 8.15822 3.16644Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_3707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleColored);
export default __webpack_public_path__ + "static/media/icon-google-colored.940425ca1a25e0bf2835d6490011236f.svg";
export { ForwardRef as ReactComponent };